
export default {
  data() {
    let me = this;
    //验证新旧密码是否一致
    let notarize = me.checkNotarizePass;
    let passStrength = me.checkPassStrength;
    return {
      constant:{
          CODE_CACHE_KEY: 'sh_logon_code',//记住密码时账号缓存关键字
          PASS_CACHE_KEY: 'sh_logon_pass',//记住密码时密码缓存关键字
      },
      userObj:{},//用户对象
      passEdit:{},//密码编辑对象
      passWnd: false,//密码编辑窗口是否显示
      rules: {//表单规则
        oldPassword: [{required: true, message: '请输入原密码', trigger: 'blur'}],
        newPassword: [{required: true, message: '请输入新密码', trigger: 'blur'},
                      {validator: passStrength, trigger: 'blur'}],
        notarize: [{required: true, message: '请输入确认新密码', trigger: 'blur'},
                   {validator: notarize, trigger: 'blur'}]
      }
    };
  },
  mounted() {
    this.initUser();
  },
  methods: {
    initUser(){
        const me = this, userStr = sessionStorage.getItem(me.$global.userObj);
        me.userObj = JSON.parse(userStr);
        console.log(me.userObj);
        if(me.userObj.changePass == 1){
            me.passWnd = true;
        }
    },
    userInfo(){
      this.$router.push('/user/center/' + this.userObj.id);
    },
    editPass(){
      this.passWnd = true;
    },
    logonOut(){
      //需要添加退出登陆接口
      this.$post({
        url:'sh/oauth/logout'
      }).then(()=>{
        sessionStorage.removeItem('token');
        this.$router.push('/login');
      }).catch(()=>{
        sessionStorage.removeItem('token');
        this.$router.push('/login');
      });
    },
    submitPass() {
      let me = this;
      me.$refs['passForm'].validate((valid) => {
        if (valid) {
          me.$post({
            url: 'sh/user/pass/modify',
            params: {
                oldPass: md5(me.passEdit.oldPassword).toUpperCase(),
                newPass: md5(me.passEdit.newPassword).toUpperCase()
            }
          }).then(rsp =>{
              if(rsp.success){
                  localStorage.removeItem(me.constant.PASS_CACHE_KEY);
                  localStorage.removeItem(me.constant.PASS_CACHE_KEY);
                  me.logonOut();
              }
          })
        } else {
          return false;
        }
      });
    },
    userClick(cmd){//用户下拉菜单点击时的命令
      this[cmd]();
    },
    checkNotarizePass(rule, value, callback){//验证新旧密码是否一致
      const me = this;
      if (!value || value == '') {
        callback(new Error('请再次输入密码'));
      } else if (value != me.passEdit.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    },
    checkPassStrength(rule, value, callback){//计算密码强度，必须包含数字，大小写，或特殊符号中的至少两种，密码长度至少8位
        if(value.length < 8){//最初级别
          callback(new Error('新密码至少8位'));
        }else{
          let level = 0;
          if(/\d/.test(value)){//如果用户输入的密码 包含了数字
              level += 1;
          }
          if(/[a-z]/.test(value)){//如果用户输入的密码 包含了小写的a到z
              level += 1;
          }
          if(/[A-Z]/.test(value)){//如果用户输入的密码 包含了大写的A到Z
              level += 1;
          }
          if(/\W/.test(value)){//如果是非数字 字母 下划线
              level += 1;
          }

          if(level < 2){
              callback("新密码至少包含数字、大小写字母及特殊符号中的两种");
          }else{
              callback();
          }
        }
    },
    reset(){
      const me = this;
      me.passEdit = {};
      me.$refs['passForm'].clearValidate();
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/user/display/src/display.js